/**
 * Auth helpers — Google ID token storage and retrieval.
 *
 * Tokens are kept in sessionStorage (per-tab, cleared on tab close).
 * On a new tab, GSI's auto_select silently re-issues the token if the
 * user is already signed into Google.
 */

const SESSION_KEY = 'google_id_token'

export function getToken(): string | null {
  return sessionStorage.getItem(SESSION_KEY)
}

export function setToken(token: string): void {
  sessionStorage.setItem(SESSION_KEY, token)
}

export function clearToken(): void {
  sessionStorage.removeItem(SESSION_KEY)
}

/** Returns headers to attach to every authenticated API request. */
export function authHeaders(): Record<string, string> {
  const token = getToken()
  if (!token) return {}
  return { Authorization: `Bearer ${token}` }
}
